import type { ReactNode } from 'react';
import { useExplorerEnv } from './explorer_env.js';
import type { ExplorerState } from './explorer_state.js';

/** A busca vencida foi refeita e a ida escolhida não voltou nela (#5588, CT-6):
 *  o aviso fica sobre a lista de idas nova até a pessoa escolher outra ida ou
 *  buscar de novo (o reducer apaga `outboundGone`). Chega depois da espera, sem
 *  gesto naquele instante — por isso é anunciado. */
export function OutboundGoneHint({ state }: Readonly<{ state: ExplorerState }>): ReactNode {
  const { copy } = useExplorerEnv();
  if (state.outboundGone !== true) return null;
  return (
    <p
      className="m-0 rounded-lg bg-warning-soft px-3 py-2 text-ui text-warning-strong"
      role="alert"
    >
      {copy.page.outboundGone}
    </p>
  );
}
